export interface IRGB {
  r: number;
  g: number;
  b: number;
}

const RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

const parseHexString = (value: string): IRGB => {
  if (!value.match(RE_HEX)) {
    throw new Error(`unknown hex color: ${value}`);
  }

  let hex = value.replace(/^#/, '');

  if (hex.length === 3) {
    hex = Array.from(hex).reduce((acc, char) => acc + char + char, '');
  }

  const u = parseInt(hex, 16);
  const r = u >> 16;
  const g = (u >> 8) & 0xff;
  const b = u & 0xff;

  return {r, g, b};
};

export const hexToRgba = (hex: string, alpha?: TChannelValue): TRGBAColor | TRGBColor => {
  const {r, g, b} = parseHexString(hex);

  if (alpha !== undefined) {
    return `rgba(${r} ${g} ${b} / ${alpha})`;
  }

  return `rgb(${r} ${g} ${b})`;
};
